import { demoQuotesStore, DemoQuote, seedDemoQuotesIfEmpty, demoDocumentsStore, demoBrokersStore } from '../utils/demo';

export interface SubmitQuoteInput {
  transperraRep: string;
  ichraEffectiveDate: string;
  pepm: string;
  currentFundingStrategy?: string;
  targetDeductible?: string;
  targetHSA?: string;
  priorityLevel?: string;
  additionalNotes?: string;
  tpaId?: string;
  brokerId: string;
  employerId: string;
  companyName: string;
  employerName: string;
  censusFile?: File[];
  planComparisonFile?: File[];
}

export const DemoQuotesService = {
  async list(): Promise<{ quotes: DemoQuote[] }> {
    seedDemoQuotesIfEmpty();
    return { quotes: demoQuotesStore.readAll() };
  },

  async updateStatus(submissionId: string, status: string): Promise<void> {
    demoQuotesStore.updateStatus(submissionId, status);
  },

  async getDocuments(submissionId: string): Promise<any[]> {
    return demoDocumentsStore.getBySubmission(submissionId);
  },

  async submitQuote(input: SubmitQuoteInput): Promise<{ submissionId: string }> {
    const submissionId = 'submission-'.concat(String(Date.now()));

    // Look up the broker name from the store
    const broker = demoBrokersStore.findById(input.brokerId);
    const brokerName = broker?.name || input.brokerId;

    const quote: DemoQuote = {
      submissionId,
      companyName: input.companyName,
      transperraRep: input.transperraRep,
      ichraEffectiveDate: input.ichraEffectiveDate,
      pepm: input.pepm || '70',
      status: 'In Progress',
      brokerName: brokerName,
      employerName: input.employerName,
      brokerId: input.brokerId,
      employerId: input.employerId,
      agency: '-',
      s3Key: `submissions/demo/${input.brokerId}/${input.employerId}/${submissionId}/submission-data.json`,
      // Set proposalGenerated to false for Legacy Metals to enable one-time proposal generation simulation
      proposalGenerated: (() => {
        console.log('DEBUG - Service companyName:', input.companyName, 'isLegacyMetals:', input.companyName === 'Legacy Metals');
        return input.companyName === 'Legacy Metals' ? false : undefined;
      })()
    };
    demoQuotesStore.upsert(quote);

    // Track uploaded file metadata in demo documents store
    const allFiles: File[] = [];
    if (input.censusFile) {
      allFiles.push(...input.censusFile);
    }
    if (input.planComparisonFile) {
      allFiles.push(...input.planComparisonFile);
    }

    if (allFiles.length > 0) {
      demoDocumentsStore.addForSubmission(submissionId, allFiles, quote, input.transperraRep);
    }

    return { submissionId };
  }
};